import React from "react";
import ReactModal from "react-modal";
import CloseBtn from "../../buttons/CloseBtn";
import { Form } from "react-bootstrap";
import RequieredInputs from "../../common/RequiredInputs";
import { hospitalsContactsActions } from "../../../actions/hospitalsContactsActions";

const NewContactNoteModal = ({
  modalIsOpen,
  closeModal,
  newContactNote,
  handleChange,
  handleSubmit,
  validateForm = () => true,
  textBtn,
}) => {
  const customStyles = {
    content: {
      width: "60%",
    },
  };

  return (
    <ReactModal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel="Nueva Nota de Contacto"
      className="custom-modal"
      ariaHideApp={false}
      style={customStyles}
    >
      <span className="custom-modal__close close-btn" onClick={closeModal}>
        <CloseBtn />
      </span>
      <h4 className="custom-modal__title">Nueva Nota de Contacto</h4>
      <Form className="products__form">
        <div>
          <Form.Group controlId="product-name">
            <Form.Label className="form__labels">
              Nota <RequieredInputs />{" "}
            </Form.Label>
            <Form.Control
              className="user-input name"
              type="text"
              as="textarea"
              rows={5}
              name="nota"
              value={newContactNote.nota}
              onChange={handleChange}
              placeholder="..."
            />
          </Form.Group>
        </div>
        <button onClick={handleSubmit} disabled={!validateForm()} className="btn save create">
          {textBtn}
        </button>
      </Form>
    </ReactModal>
  );
};
ReactModal.setAppElement("#root");
export default NewContactNoteModal;
